import { useState } from "react"

import { AppError, parseErrorAsObj } from "../../../../errors/errorProcessors"
import { IAppError } from "../../../../errors/errorTypes"
import { getClientProtected } from "../../clients/clients"
import { companySearchMapper } from "../../mappers/companySearch/companySearchMapper"
import { IOrganisationDetails } from "../../types/companySearch/companySearchTypes"
import { COMPANY_SEARCH_API } from "../../urls/hybrid"

interface IUseCompanySearchOutput {
    isSearching: boolean
    getCompanies: (searchTerm: string) => Promise<void>
    searchResults: IOrganisationDetails | undefined
    error: IAppError | undefined
}

/**
 * Hook for searching for a company.
 * @returns {IUseCompanySearchOutput} - SWR data, loading and error states.
 */

// TODO - loading stat
const useCompanySearch = (): IUseCompanySearchOutput => {
    const [searchResults, setSearchResults] = useState<
        IOrganisationDetails | undefined
    >(undefined)
    const [isSearching, setIsSearching] = useState(false)
    const [error, setError] = useState<IAppError | undefined>(undefined)
    const getCompanies = async (searchTerm: string): Promise<void> => {
        try {
            setError(undefined)
            setIsSearching(true)
            if ((searchTerm || "").length < 2) {
                throw new AppError(
                    "Search term must be at least 2 characters long",
                    400,
                    "Your search term must be at least 2 characters long",
                    "Search term must be at least 2 characters long",
                    "warning"
                )
            }
            setSearchResults(undefined)
            const res = await getClientProtected(COMPANY_SEARCH_API(searchTerm))
            setSearchResults(companySearchMapper.mapOrganisationDetails(res))
        } catch (err) {
            setError(parseErrorAsObj(err))
        } finally {
            setIsSearching(false)
        }
    }

    return {
        searchResults,
        isSearching,
        getCompanies,
        error,
    }
}

export default useCompanySearch
